[
  "player_character_private",
  "player_character_deleted",
  "player_character_created_by_id",
  "player_character_updated_by_id",
  "player_originally_created_by_user_id",
  "player_character_allow_copying",
  "item_id",
  "player_name",
  "campaign_invite_code",
  "attached_campaign_id",
  "player_character_inactive",
  "ancestry_1",
  "ancestry_2",
  "ancestry_choice_1",
  "ancestry_choice_2",
  "ancestry_choice_3",
  "lineage",
  "body_input_default",
  "body_input_other",
  "body_input_override",
  "mind_input_default",
  "mind_input_other",
  "mind_input_override",
  "soul_input_default",
  "soul_input_other",
  "soul_input_override",
  "spirit_input_other",
  "spirit_input_override",
  "fortune_input_other",
  "fortune_input_override",
  "class_1",
  "class_level_1",
  "subclass_1",
  "class_2",
  "class_level_2",
  "subclass_2",
  "class_3",
  "class_level_3",
  "subclass_3",
  "class_4",
  "class_level_4",
  "subclass_4",
  "class_5",
  "class_level_5",
  "subclass_5",
  "class_6",
  "class_level_6",
  "subclass_6",
  "class_7",
  "class_level_7",
  "subclass_7",
  "class_8",
  "class_level_8",
  "subclass_8",
  "class_9",
  "class_level_9",
  "subclass_9",
  "class_10",
  "class_level_10",
  "subclass_10",
  "class_11",
  "class_level_11",
  "subclass_11",
  "class_12",
  "class_level_12",
  "subclass_12",
  "class_13",
  "class_level_13",
  "subclass_13",
  "class_14",
  "class_level_14",
  "subclass_14",
  "class_15",
  "class_level_15",
  "subclass_15",
  "class_16",
  "class_level_16",
  "subclass_16",
  "class_17",
  "class_level_17",
  "subclass_17",
  "class_18",
  "class_level_18",
  "subclass_18",
  "class_19",
  "class_level_19",
  "subclass_19",
  "class_20",
  "class_level_20",
  "subclass_20",
  "sp_a_fortitude",
  "sp_t_fortitude",
  "sp_as_fortitude",
  "sp_a_psyche",
  "sp_t_psyche",
  "sp_as_psyche",
  "sp_a_willpower",
  "sp_t_willpower",
  "sp_as_willpower",
  "sp_a_attention",
  "sp_t_attention",
  "sp_as_attention",
  "sp_a_balance",
  "sp_t_balance",
  "sp_as_balance",
  "sp_a_empathy",
  "sp_t_empathy",
  "sp_as_empathy",
  "sp_a_frighten",
  "sp_t_frighten",
  "sp_as_frighten",
  "sp_a_influence",
  "sp_t_influence",
  "sp_as_influence",
  "sp_a_initiative",
  "sp_t_initiative",
  "sp_as_initiative",
  "sp_a_inspection",
  "sp_t_inspection",
  "sp_as_inspection",
  "sp_a_sneak",
  "sp_t_sneak",
  "sp_as_sneak",
  "sp_a_excavating",
  "sp_t_excavating",
  "sp_as_excavating",
  "sp_a_farming",
  "sp_t_farming",
  "sp_as_farming",
  "sp_a_fishing",
  "sp_t_fishing",
  "sp_as_fishing",
  "sp_a_herbalism",
  "sp_t_herbalism",
  "sp_as_herbalism",
  "sp_a_hunting",
  "sp_t_hunting",
  "sp_as_hunting",
  "sp_a_locks",
  "sp_t_locks",
  "sp_as_locks",
  "sp_a_mining",
  "sp_t_mining",
  "sp_as_mining",
  "sp_a_skinning",
  "sp_t_skinning",
  "sp_as_skinning",
  "sp_a_architecture",
  "sp_t_architecture",
  "sp_as_architecture",
  "sp_a_art",
  "sp_t_art",
  "sp_as_art",
  "sp_a_astronomy",
  "sp_t_astronomy",
  "sp_as_astronomy",
  "sp_a_biology",
  "sp_t_biology",
  "sp_as_biology",
  "sp_a_civics",
  "sp_t_civics",
  "sp_as_civics",
  "sp_a_finance",
  "sp_t_finance",
  "sp_as_finance",
  "sp_a_gamesmanship",
  "sp_t_gamesmanship",
  "sp_as_gamesmanship",
  "sp_a_geology",
  "sp_t_geology",
  "sp_as_geology",
  "sp_a_history",
  "sp_t_history",
  "sp_as_history",
  "sp_a_law",
  "sp_t_law",
  "sp_as_law",
  "sp_a_linguistics",
  "sp_t_linguistics",
  "sp_as_linguistics",
  "sp_a_magic",
  "sp_t_magic",
  "sp_as_magic",
  "sp_a_medicine",
  "sp_t_medicine",
  "sp_as_medicine",
  "sp_a_music",
  "sp_t_music",
  "sp_as_music",
  "sp_a_navigation",
  "sp_t_navigation",
  "sp_as_navigation",
  "sp_a_planes",
  "sp_t_planes",
  "sp_as_planes",
  "sp_a_religion",
  "sp_t_religion",
  "sp_as_religion",
  "sp_a_alchemy",
  "sp_t_alchemy",
  "sp_as_alchemy",
  "sp_a_cooking",
  "sp_t_cooking",
  "sp_as_cooking",
  "sp_a_enchanting",
  "sp_t_enchanting",
  "sp_as_enchanting",
  "sp_a_glassblowing",
  "sp_t_glassblowing",
  "sp_as_glassblowing",
  "sp_a_jewelling",
  "sp_t_jewelling",
  "sp_as_jewelling",
  "sp_a_leatherworking",
  "sp_t_leatherworking",
  "sp_as_leatherworking",
  "sp_a_machining",
  "sp_t_machining",
  "sp_as_machining",
  "sp_a_masoning",
  "sp_t_masoning",
  "sp_as_masoning",
  "sp_a_smithing",
  "sp_t_smithing",
  "sp_as_smithing",
  "sp_a_weaving",
  "sp_t_weaving",
  "sp_as_weaving",
  "sp_a_woodworking",
  "sp_t_woodworking",
  "sp_as_woodworking",
  "sp_a_abolian",
  "sp_t_abolian",
  "sp_as_abolian",
  "sp_a_abyssal",
  "sp_t_abyssal",
  "sp_as_abyssal",
  "sp_a_aquan",
  "sp_t_aquan",
  "sp_as_aquan",
  "sp_a_auran",
  "sp_t_auran",
  "sp_as_auran",
  "sp_a_common",
  "sp_t_common",
  "sp_as_common",
  "sp_a_domir",
  "sp_t_domir",
  "sp_as_domir",
  "sp_a_draconic",
  "sp_t_draconic",
  "sp_as_draconic",
  "sp_a_druidic",
  "sp_t_druidic",
  "sp_as_druidic",
  "sp_a_dwarvish",
  "sp_t_dwarvish",
  "sp_as_dwarvish",
  "sp_a_elvish",
  "sp_t_elvish",
  "sp_as_elvish",
  "sp_a_enochian",
  "sp_t_enochian",
  "sp_as_enochian",
  "sp_a_gnomish",
  "sp_t_gnomish",
  "sp_as_gnomish",
  "sp_a_grel",
  "sp_t_grel",
  "sp_as_grel",
  "sp_a_ignan",
  "sp_t_ignan",
  "sp_as_ignan",
  "sp_a_nagh",
  "sp_t_nagh",
  "sp_as_nagh",
  "sp_a_orcish",
  "sp_t_orcish",
  "sp_as_orcish",
  "sp_a_primordial",
  "sp_t_primordial",
  "sp_as_primordial",
  "sp_a_qini",
  "sp_t_qini",
  "sp_as_qini",
  "sp_a_sign_language",
  "sp_t_sign_language",
  "sp_as_sign_language",
  "sp_a_sylvan",
  "sp_t_sylvan",
  "sp_as_sylvan",
  "sp_a_terran",
  "sp_t_terran",
  "sp_as_terran",
  "sp_a_thieves_cant",
  "sp_t_thieves_cant",
  "sp_as_thieves_cant",
  "sp_a_umbral",
  "sp_t_umbral",
  "sp_as_umbral",
  "sp_a_cymbals",
  "sp_t_cymbals",
  "sp_as_cymbals",
  "sp_a_drums",
  "sp_t_drums",
  "sp_as_drums",
  "sp_a_flutes",
  "sp_t_flutes",
  "sp_as_flutes",
  "sp_a_harps",
  "sp_t_harps",
  "sp_as_harps",
  "sp_a_horns",
  "sp_t_horns",
  "sp_as_horns",
  "sp_t_keyboards",
  "sp_as_keyboards",
  "sp_a_keyboards",
  "sp_a_pipes",
  "sp_t_pipes",
  "sp_as_pipes",
  "sp_a_stringed_bow",
  "sp_t_stringed_bow",
  "sp_as_stringed_bow",
  "sp_a_stringed_plucked",
  "sp_t_stringed_plucked",
  "sp_as_stringed_plucked",
  "sp_a_zithers",
  "sp_t_zithers",
  "sp_as_zithers",
  "sp_a_natural_weapon_skill",
  "sp_t_natural_weapon_skill",
  "sp_as_natural_weapon_skill",
  "sp_a_one_handed_melee_weapon_skill",
  "sp_t_one_handed_melee_weapon_skill",
  "sp_as_one_handed_melee_weapon_skill",
  "sp_a_two_handed_melee_weapon_skill",
  "sp_t_two_handed_melee_weapon_skill",
  "sp_as_two_handed_melee_weapon_skill",
  "sp_a_archery_weapon_skill",
  "sp_t_archery_weapon_skill",
  "sp_as_archery_weapon_skill",
  "sp_a_firearms_weapon_skill",
  "sp_t_firearms_weapon_skill",
  "sp_as_firearms_weapon_skill",
  "sp_a_throwable_weapon_skill",
  "sp_t_throwable_weapon_skill",
  "sp_as_throwable_weapon_skill",
  "sp_a_bending_weapon_skill",
  "sp_t_bending_weapon_skill",
  "sp_as_bending_weapon_skill",
  "sp_a_heavy_armor_skill",
  "sp_t_heavy_armor_skill",
  "sp_as_heavy_armor_skill",
  "sp_a_light_armor_skill",
  "sp_t_light_armor_skill",
  "sp_as_light_armor_skill",
  "sp_a_medium_armor_skill",
  "sp_t_medium_armor_skill",
  "sp_as_medium_armor_skill",
  "sp_a_natural_armor_skill",
  "sp_t_natural_armor_skill",
  "sp_as_natural_armor_skill",
  "sp_a_shield_armor_skill",
  "sp_t_shield_armor_skill",
  "sp_as_shield_armor_skill",
  "v_max_override",
  "experience_marks",
  "player_description",
  "background",
  "lifestyle",
  "faith",
  "hair",
  "eyes",
  "skin",
  "height",
  "weight",
  "age",
  "gender",
  "player_traits",
  "player_ideals",
  "player_bonds",
  "player_flaws",
  "organizations",
  "enemies",
  "backstory",
  "other_notes",
  "permissioned",
  "player_username",
  "player_email",
  "player_email_updates",
  "player_geoplugin_timezone",
  "player_originally_username"
]
